




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class EmailDisplay extends Vue {
  @Prop({ type: String })
  private email!: string | null

  private get mailto() {
    return `mailto:${this.email}`
  }
}
